import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Edit = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 23 24'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M19.047 3.004c-.285 0-.558.118-.76.328L9.65 12.346a1 1 0 0 0-.243.426l-.56 1.996 1.914-.584a.95.95 0 0 0 .409-.252l8.637-9.014c.202-.21.315-.495.315-.793 0-.297-.113-.582-.315-.793a1.05 1.05 0 0 0-.76-.328m-2.115-1.086a2.93 2.93 0 0 1 2.115-.914 2.93 2.93 0 0 1 2.115.914c.561.585.877 1.38.877 2.207 0 .828-.316 1.622-.877 2.207l-8.637 9.014a2.85 2.85 0 0 1-1.227.758l-2.753.84c-.247.075-.51.08-.76.013a1.4 1.4 0 0 1-.66-.392 1.5 1.5 0 0 1-.375-.689c-.064-.26-.06-.534.012-.792l.806-2.874a3 3 0 0 1 .727-1.278zm-14.173.96A2.82 2.82 0 0 1 4.792 2H11.5c.53 0 .959.448.959 1 0 .553-.43 1-.959 1H4.792a.94.94 0 0 0-.678.293c-.18.188-.28.442-.28.707v14c0 .265.1.52.28.707.18.188.424.293.678.293h13.417a.94.94 0 0 0 .677-.293 1.02 1.02 0 0 0 .281-.707v-7c0-.552.43-1 .958-1 .53 0 .959.448.959 1v7a3.07 3.07 0 0 1-.842 2.122c-.54.562-1.27.878-2.033.878H4.792a2.82 2.82 0 0 1-2.033-.878A3.07 3.07 0 0 1 1.917 19V5c0-.795.303-1.558.842-2.121z'
        clipRule='evenodd'
      />
    </svg>
  );
};
